import React from 'react'
import { Link } from 'react-router-dom'
import { Header, Transition, Container, Icon } from 'semantic-ui-react'
import flags from 'common/flags'

const ActivationMaintenance = () => (
  <Transition animation="fade up" transitionOnMount>
    <Container text>
      <Header as="h1" textAlign="center" icon style={{ paddingTop: 90 }}>
        <Icon name="wrench" color="grey" />
        New activations are temporarily unavailable
        <Header.Subheader style={{ marginTop: '1em' }}>
          We&apos;re performing scheduled maintenance. New SIM activations will be back from{' '}
          {flags.activation_maintenance?.note || '9am on Monday 24 August'}.
        </Header.Subheader>
        <Header.Subheader style={{ marginTop: '1em' }}>
          If you already have an account, you can still <Link to="/login/">log in</Link> to manage
          your service.
        </Header.Subheader>
      </Header>
    </Container>
  </Transition>
)

export default ActivationMaintenance
